import React from 'react';
import {
  Check as CheckedIcon,
  Remove as IndeterminateIcon,
} from '@mui/icons-material';
import {getOverlayAlpha} from '@mui/material';

import {round} from './utils.js';

// Component Overrides object (Sorted Alphabetically)
// Used as the value of `components` property in `createTheme` config object.
export default {
  MuiCssBaseline: {
    styleOverrides: theme => ({
      'html, body': {
        height: '100%',
        '&, &::backdrop': {
          backgroundColor: (theme.vars || theme).palette.background.paper,
          fontFeatureSettings: `'kern' 1, 'ss01' 1`, // alternative numbers
          fontVariantNumeric: 'tabular-nums', // monospaced numbers
        },
      },
      'input[type="number"]': {
        '&::-webkit-inner-spin-button': {
          background: `transparent url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKAQMAAABCAtZOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIwMjAgTWFjaW50b3NoIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU5MEIxNkZDRDBENzExRUE4OEFBRTEzMUQxMTI3QzU2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU5MEIxNkZERDBENzExRUE4OEFBRTEzMUQxMTI3QzU2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTkwQjE2RkFEMEQ3MTFFQTg4QUFFMTMxRDExMjdDNTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTkwQjE2RkJEMEQ3MTFFQTg4QUFFMTMxRDExMjdDNTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5OiLTZAAAABlBMVEVIbnEAAACz7T8bAAAAAnRSTlP/AOW3MEoAAAAaSURBVAjXY3jHcIyhiYGB4R8QMgBZxxjeAQBAJAZpFFUMegAAAABJRU5ErkJggg==') no-repeat 0% 49%`,
          ...theme.applyStyles('dark', {
            background: `transparent url(
                 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKAQMAAABCAtZOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIwMjAgTWFjaW50b3NoIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNFNjE3MzRGRDBENTExRUE4OEFBRTEzMUQxMTI3QzU2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNFNjE3MzUwRDBENTExRUE4OEFBRTEzMUQxMTI3QzU2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0U2MTczNEREMEQ1MTFFQTg4QUFFMTMxRDExMjdDNTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0U2MTczNEVEMEQ1MTFFQTg4QUFFMTMxRDExMjdDNTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7GkPa7AAAABlBMVEWer7EAAADVsu9EAAAAAnRSTlP/AOW3MEoAAAAaSURBVAjXY3jHcIyhiYGB4R8QMgBZxxjeAQBAJAZpFFUMegAAAABJRU5ErkJggg=='
            ) no-repeat 0% 49%`,
          }),
          bottom: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          WebkitAppearance: 'none',
          width: '1em',
        },
        '&::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
        },
        position: 'relative',
      },
    }),
  },
  MuiAvatar: {
    variants: [
      {
        props: {size: 'xsmall'},
        style: ({theme}) => ({
          fontSize: theme.spacing(1.5),
          width: theme.spacing(3),
          height: theme.spacing(3),
        }),
      },
      {
        props: {size: 'small'},
        style: ({theme}) => ({
          fontSize: theme.spacing(2),
          width: theme.spacing(4),
          height: theme.spacing(4),
        }),
      },
      {
        props: {size: 'medium'},
        style: ({theme}) => ({
          fontSize: theme.spacing(2.5),
          width: theme.spacing(5),
          height: theme.spacing(5),
        }),
      },
      {
        props: {size: 'large'},
        style: ({theme}) => ({
          fontSize: theme.spacing(3),
          width: theme.spacing(6),
          height: theme.spacing(6),
        }),
      },
    ],
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: `rgba(22, 24, 34, 0.65)`, //#161822
      },
      invisible: {
        backgroundColor: 'transparent',
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    variants: [
      // Mini Variant
      {
        props: {size: 'mini'},
        style: ({theme}) => ({
          padding: theme.spacing(0.5, 1),
          fontSize: theme.typography.pxToRem(12),
          lineHeight: round(16 / 12),
          minHeight: 24,
          height: 24,
        }),
      },
    ],
  },
  MuiCheckbox: {
    defaultProps: {
      indeterminateIcon: <IndeterminateIcon />,
      checkedIcon: <CheckedIcon />,
    },
    styleOverrides: {
      root: ({theme}) => ({
        width: 36,
        height: 36,
        // Input
        '& input': {
          width: 36,
          height: 36,
        },
        // Box
        '&::after': {
          content: '""',
          width: 20,
          height: 20,
          display: 'block',
          border: `1px solid ${(theme.vars || theme).palette.text.secondary}`,
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate3d(-50%, -50%, 0)',
          borderRadius: theme.shape.borderRadius,
        },
        // Unchecked (don't show icon)
        '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root':
          {
            visibility: 'hidden',
          },
        // Disabled
        '&.Mui-disabled': {
          '&.Mui-checked .MuiSvgIcon-root': {
            display: 'inherit',
          },
          '&::after': {
            backgroundColor: (theme.vars || theme).palette.action
              .disabledBackground,
          },
        },
      }),
    },
  },
  MuiChip: {
    styleOverrides: {
      icon: ({theme}) => ({
        marginRight: theme.spacing(0.5),
        variants: [
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              marginRight: theme.spacing(-0.5),
            },
          },
        ],
      }),
      label: ({theme}) => ({
        paddingRight: 0,
        paddingLeft: 0,
        variants: [
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              paddingRight: theme.spacing(1),
            },
          },
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              paddingLeft: theme.spacing(1),
            },
          },
        ],
      }),
    },
    variants: [
      {
        props: {shape: 'square'},
        style: ({theme}) => ({
          borderRadius: theme.shape.borderRadius,
        }),
      },
      {
        props: {size: 'xsmall'},
        style: ({theme}) => ({
          height: theme.spacing(2.25),
          '& .MuiChip-label': {
            paddingLeft: theme.spacing(0.75),
            paddingRight: theme.spacing(0.75),
            fontSize: theme.typography.pxToRem(12),
          },
        }),
      },
    ],
  },
  MuiDialog: {
    defaultProps: {
      PaperProps: {
        elevation: 8,
      },
    },
    styleOverrides: {
      paper: ({theme}) => ({
        // force background image of elevation 8 at all times since PaperProps can be overriden
        // https://github.com/mui/material-ui/issues/37585
        ...(!theme.vars &&
          theme.palette.mode === 'dark' && {
            backgroundImage: `linear-gradient(rgba(255,255,255, ${getOverlayAlpha(8)}),
            )}, rgba(255,255,255, ${getOverlayAlpha(8)})`,
          }),
      }),
      paperWidthXs: ({theme}) => ({
        '&.MuiDialog-paperScrollBody': {
          [theme.breakpoints.down(
            Math.max(theme.breakpoints.values.xs, 535) + 32 * 2,
          )]: {
            maxWidth: 'calc(100% - 64px)',
          },
        },
        maxWidth: Math.max(theme.breakpoints.values.xs, 535),
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({theme}) => ({
        padding: theme.spacing(2),
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({theme}) => ({
        padding: theme.spacing(2),
      }),
      spacing: {
        variants: [
          {
            props: ({ownerState}) => !ownerState.disableSpacing,
            style: ({theme}) => ({
              '& > :not(style) ~ :not(style)': {
                marginLeft: theme.spacing(2),
              },
            }),
          },
        ],
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: ({theme}) => ({
        width: 38,
        height: 38,
        '&::before': {
          content: "''",
          width: 20,
          height: 20,
          borderRadius: '50%',
          border: `1px solid ${theme.palette.text.secondary}`,
          position: 'absolute',
        },
        '& .MuiSvgIcon-root': {
          display: 'none', // Hide Both Icons
          // 1st SVG is the outer (border) icon
          //'&:first-of-type': {},
          // 2nd SVG is the inner (checked) icon
          '&:nth-of-type(2)': {
            left: '50%',
            top: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
            width: 29,
            height: 29,
          },
        },
        '&.Mui-checked': {
          '& .MuiSvgIcon-root:nth-of-type(2)': {
            display: 'inherit',
          },
        },
        '&.Mui-disabled': {
          '&::before': {
            backgroundColor: (theme.vars || theme).palette.action
              .disabledBackground,
          },
        },
      }),
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        alignItems: 'center',
      },
      track: ({theme}) => ({
        borderRadius: 3.5,
        height: theme.spacing(1),
      }),
    },
  },
};
